import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import StatusBadge from "../../components/StatusBadge";
import { Button } from "../../components/ui/button";
import { Mail, Phone, GraduationCap } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/inquiries").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/inquiries/${id}`, { status });
    toast.success(`Marked ${status}.`); load();
  };

  return (
    <AppShell admin>
      <h1 className="font-display text-3xl font-bold text-navy">Inquiries</h1>
      <p className="text-slateBrand">Family inquiries and registration requests from the contact form.</p>

      <div className="mt-8 space-y-4">
        {items.length === 0 && <p className="text-sm text-slateBrand">No inquiries yet.</p>}
        {items.map((q) => (
          <div key={q.id} data-testid={`inquiry-${q.id}`} className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="flex items-center gap-2 font-display font-bold text-navy">
                  {q.parent_name}
                  {q.step_up_user && <span className="inline-flex items-center gap-1 rounded-full bg-gold/15 px-2 py-0.5 text-[0.65rem] font-bold text-[#8A5F00]"><GraduationCap className="h-3 w-3" />Step Up</span>}
                </div>
                <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slateBrand">
                  <a href={`mailto:${q.email}`} className="inline-flex items-center gap-1 hover:text-brandblue"><Mail className="h-3 w-3" />{q.email}</a>
                  {q.phone && <a href={`tel:${q.phone}`} className="inline-flex items-center gap-1 hover:text-brandblue"><Phone className="h-3 w-3" />{q.phone}</a>}
                  <span>{new Date(q.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span>
                </div>
              </div>
              <StatusBadge status={q.status === "new" ? "pending" : "complete"} label={q.status} />
            </div>
            <div className="mt-3 grid gap-x-6 gap-y-1 text-sm text-slateBrand sm:grid-cols-2">
              {q.student_name && <div>Student: <span className="text-navy">{q.student_name}{q.student_age ? ` (age ${q.student_age})` : ""}</span></div>}
              {q.interest && <div>Interest: <span className="text-navy">{q.interest}</span></div>}
              {q.preferred_date && <div>Preferred date: <span className="text-navy">{q.preferred_date}</span></div>}
            </div>
            {q.message && <p className="mt-2 rounded-lg bg-cloud p-3 text-sm text-slateBrand">{q.message}</p>}
            <div className="mt-4 flex gap-2">
              <Button size="sm" variant="outline" data-testid={`inquiry-contacted-${q.id}`} onClick={() => setStatus(q.id, "contacted")}>Mark Contacted</Button>
              <Button size="sm" variant="outline" data-testid={`inquiry-closed-${q.id}`} onClick={() => setStatus(q.id, "closed")}>Close</Button>
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
